export const UPGRADES = [
  ...Array.from({ length: 8 }, (_, index) => ({
    id: `tier-${index + 1}-one`,
    line: 'I',
    tier: index + 1,
    name: `Tier ${index + 1} field drills`,
    detail: `Double ${index + 1 === 1 ? 'Recruit' : 'tier'} output once.`,
    multiplier: 2,
    cost: (index + 1) * 100,
    unlock: 1,
  })),
  ...Array.from({ length: 8 }, (_, index) => ({
    id: `tier-${index + 1}-two`,
    line: 'I',
    tier: index + 1,
    name: `Tier ${index + 1} standing orders`,
    detail: `Double tier ${index + 1} output again.`,
    multiplier: 2,
    cost: (index + 1) * 1000,
    unlock: 1,
    requires: `tier-${index + 1}-one`,
  })),
  {
    id: 'cross-tier', line: 'II', tier: null, name: 'Inter-service handover', detail: 'Every tier below 5 produces +50%.', multiplier: 1.5, cost: 250000, unlock: 6,
  },
  {
    id: 'fusion-doctrine', line: 'III', tier: null, name: 'Fusion doctrine', detail: 'Each Fusion Centre grants +1% to all other units.', multiplier: 1, cost: 25000000, unlock: 12,
  },
];

export function upgradeFor(id) { return UPGRADES.find((upgrade) => upgrade.id === id); }
